import { NgModule } from 'ng-metadata/core';
import {PrmDidUMean} from './didUMean.directive';

@NgModule({
    declarations: [PrmDidUMean],
    providers: [
    ],
    imports:[

    ]
})
export class DidUMeanModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/didUMean/didUMean.module.ts